
import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import AboutSection from './components/AboutSection';
import TermsConditions from './components/TermsConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import ContactInfo from './pages/ContactInfo';
import Enquiry from './pages/Enquiry';
import Gallery from './pages/Gallery';
import Footer from './components/Footer';
import Mumbaioutstationcabs from './pages/Mumbai Outstation Cabs';
import MumbaiToMahabaleshwarCab from './pages/Mumbai to Mahabaleshwar Cab';
import Mumbaitogoacabs from './pages/Mumbai to Goa Cabs';
import Mumbaitoshirdicaab from './pages/Mumbai to Shirdi Cab';
import Mumbaitonashikcab from './pages/Mumbai to Nashik Cab';
import Mumbaitokolhapurcab from './pages/Mumbai to Kolhapur Cab';
import Mumbaitopunecab from './pages/Mumbai to Pune Cab';
import Mumbaitoaurangabadcab from './pages/Mumbai to Aurangabad Cab';
import Mumbaitobhimashankarcab from './pages/Mumbai to Bhimashankar Cab';
import Mumbaitoashtavinayakcabservice from './pages/Mumbai to Ashtavinayak Cab Service';
import Mumbaitofivejyotilingacab from './pages/Mumbai to 5 Jyotirlinga Cab';
import Mumbaitolonavalacab from './pages/Mumbai to Lonavala Cab';
import Mumbaitokonkandarshancabbooking from './pages/Mumbai to Konkan Darshan Cab Booking';
import ScrollToTop from './components/ScrollToTop';
import Mumbaitoalibaugcabs from './pages/Mumbai to Alibaug Cab';
import Mumbaitoahmednagarcab from './pages/Mumbai to Ahmednagar Cab';
import Mumbaitomatherancab from './pages/Mumbai to Matheran Cab';
import Mumbaitojalgaoncabbookingdhule from './pages/Mumbai to Jalgaon Cab Booking  Dhule';
import Mumbaitolavasacab from './pages/Mumbai to Lavasa Cab';
import Mumbaitopachmanicab from './pages/Mumbai to Panchgani Cab';
import Mumbaitokhandalataxifare from './pages/Mumbai to Khandala Taxi Fare';
import Mumbaitosuratcab from './pages/Mumbai to Surat Cab';
import MumbaitoahmedabadCab from './pages/Mumbai to Ahmedabad Cab';
import Mumbaitonarmadaparikramacabbooking from './pages/Mumbai to Narmada Parikrama Cab Booking';
import Mumbaitobarodacabs from './pages/Mumbai to Baroda Cabs';
import Mumbaitodamantaxi from './pages/Mumbai to Daman Taxi';
import Mumbaitovapicabs from './pages/Mumbai to Vapi Cab';
import Mumbaitobangorecab from './pages/Mumbai to Bangalore Cab';
import Mumbaitoindorecab from './pages/Mumbai to Indore Cab';
import Mumbaitojaipurtaxi from './pages/Mumbai to Jaipur Taxi';
import Mumbaiairporttopunecabs from './pages/Mumbai Airport to Pune Cabs';
import Mumbaitoimagicacab from './pages/Mumbai to Imagica Cab';
import Cabserviceinmumbai from './pages/Cab Service in Mumbai';
import BestTaxiServiceInMumbai from './pages/Best Taxi Service in Mumbai';
import Onlinetaxibookingmumbai from './pages/Online Taxi Booking Mumbai';
import Mumbaidarshancabs from './pages/Mumbai Darshan Cabs';
import Weddingcaerentalmumbai from './pages/Wedding Car Rental Mumbai';
import Onewaycabservice from './pages/One Way Cab Service';
import Corporatecabserviceinmumbai from './pages/Corporate Cab Services in Mumbai';
import Cabcompaniesinmumbai from './pages/Cab Companies in Mumbai';
import Mumbaicarrenatlservice from './pages/Mumbai Car Rental Service';
import Roundtripbookingmumbai from './pages/Round Trip Cab Booking Mumbai';
import Cabserviceinthane from './pages/Cab Service in Thane';
import Cabservicenearmemumbai from './pages/Cab Service Near Me Mumbai';
import Swiftdzireonrentinmumbai from './pages/Swift Dzire on Rent in Mumbai';
import Cabserviceinnavimumbai from './pages/Cab Service in Navi Mumbai';
import Taxiserviceatmumbaiinternationalairport from './pages/Taxi Service at Mumbai International Airport';
import Cabserviceinkalyancabserviceindombivali from './pages/Cab Service in Kalyan  Cab Service in Dombivali';
import Innovacarrentalmumbai from './pages/Innova Car Rental Mumbai';
import InnovaCrystaOnRentInMumbai from './pages/Innova Crysta on Rent in Mumbai.';
import ErtigaOnRentInMumbai from './pages/Ertiga On Rent in Mumbai';
import SedanCabServiceMumbai from './pages/Sedan Cab Service Mumbai';
import TempoTravellerOnRentMumbai from './pages/Tempo Traveller On Rent Mumbai';
import Minibusonretinmumbai from './pages/Mini Bus on Rent in Mumbai';
import Kiacarencecabserviceinmumbai from './pages/Kia Carens Cab Service in Mumbai';
import Toyotaetiononrentinmumbai from './pages/Toyota Etios on Rent in Mumbai';
import Carrentalmumbai from './pages/Car Rental Mumbai';
import Exploreindiapanindiacab from './pages/Explore India  Pan India Cab Booking Services';
import MumbaitopandharpurAkkalkotTuljapurCabBooking from './pages/Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking';
import Outstationtaxiserviceinmumbai from './pages/Outstation Taxi Service in Mumbai';
import Carhireforoutstationinmumbai from './pages/Car Hire for Outstation in Mumbai';
import Mumbaitohyderabadcabs from './pages/Mumbai to Hyderabad Cabs';
import Mumbaicabservice from './pages/Mumbai Cab Service';
import Bestcabserviceinmumbai from './pages/Best Cab Service in Mumbai';
import Mumbaitoayodhyacab from './pages/Mumbai to Ayodhya Cab';
import Mumbaitosaputaracabs from './pages/Mumbai to Saputara Cabs';
import Mumbaitobhopalcab from './pages/Mumbai to Bhopal Cab';
import Mumbaitotelanganacabservice from './pages/Mumbai to Telangana Cab Service';
import Mumbaitoshanishiignapurcab from './pages/Mumbai to Shani Shingnapur Cab';
import Mumbaitotrimbkeshwarcab from './pages/Mumbai to Trimbakeshwar Cab';
import Mumbaiairporttovadodaracab from './pages/Mumbai Airport to Vadodara Cab';
import Mumbaitosolapurcab from './pages/Mumbai to Solapur Cab';
import Mumbaitoratnagirircab from './pages/Mumbai to Ratnagiri Cab';
import Mumbaitogridhneshwarcab from './pages/Mumbai to Grishneshwar Cab';
import Mumbaitopalgharcab from './pages/Mumbai to Palghar Cab';
import Mumbaitoujjaincab from './pages/Mumbai to Ujjain Cab';
import Mumbaitojaipurcab from './pages/Mumbai to Jaipur Cab';
import Mumbaitogujratcab from './pages/Mumbai to Gujarat Cab';
import Innovaonrentmumbai from './pages/Innova On Rent Mumbai';
import Kiacarenceonrentinmumbai from './pages/Kia Carens On Rent in Mumbai';
import NavimumbaiAirportCab from './pages/Navi Mumbai Airport Cab';
import NaviMumbaiAirportCabService from './pages/Navi Mumbai Airport Cab Service';
import NavimummbaiAirportToPuneCab from './pages/Navi Mumbai Airport to Pune Cab';
import NaviMumbaiAirportToNashikCab from './pages/Navi Mumbai Airport to Nashik Cab';
import Onlinecabbookingnavimumbaiairport from './pages/Online Cab Booking Navi Mumbai Airport';
import NavimumbaiAirportToLonavalaCabs from './pages/Navi Mumbai Airport to Lonavala Cabs';
import MumbaiAirportCabService from './pages/Mumbai Airport Cab Service';
import NavimumbaiToMahabaleshwarCab from './pages/Navi Mumbai to Mahabaleshwar Cab';
import NavimumbaitoshirdiTaxiFare from './pages/Navi Mumbai to Shirdi Taxi Fare';
import Navimumbaitaxiservice from './pages/Navi Mumbai Taxi Service';
import Cheapestcabserviceinmumbai from './pages/Cheapest Cab Service in Mumbai';
import NavimumbaiToKolhapurCab from './pages/Navi Mumbai to Kolhapur Cab';
import InnovacrystaOnRentNaviMumbai from './pages/Innova Crysta On Rent in Navi Mumbai';
import Ertigaonrentinnavimumbai from './pages/Ertiga On Rent in Navi Mumbai';
import SwiftDzireOnRentInNaviMumbai from './pages/Swift Dzire On Rent in Navi Mumbai';
import NaviMumbaiAirportToGoaCabs from './pages/Navi Mumbai Airport to Goa Cabs';
import Navimumbaiinternatinalairportcab from './pages/Navi Mumbai International Airport Cab';
import NavimumbaiToAshtavinayakCabService from './pages/Navi Mumbai to Ashtavinayak Cab Service';
import Navimumbaitofivejyotilingadarshan from './pages/Navi Mumbai to 5 Jyotirlinga Darshan Cab';
import Roundtripcabnavimumbai from './pages/Round Trip Cab Navi Mumbai';
import OutstationCabServiceNaviMumbai from './pages/Outstation Cab Service Navi Mumbai';
import NavimumbaitopuneDailyCabService from './pages/Navi Mumbai to Pune Daily Cab Service';
import NaviMumbaiCorporateCabService from './pages/Navi Mumbai Corporate Cab Service';
import NavimumbaiinternationalAirportCabs from './pages/Navi Mumbai International Airport (NMIA) Cabs';
import MumbaiToKhatuShyamCab from './pages/Mumbai to Khatu Shyam Cab';
import Mumbaitonagpurcab from './pages/Mumbai to Nagpur Cab';
import Mumbaitopimprichichwadcabs from './pages/Mumbai to Pimpri Chinchwad Cabs';
import NaviMumbaiToGoaCabService from './pages/Navi Mumbai to Goa Cab Service';
import Mumbaiairporttogoacab from './pages/Mumbai Airport to Goa Cab';
import MumbaiToGoaOneWayCab from './pages/Mumbai to Goa One Way Cab';
import ThaneToGoaCabs from './pages/Thane to Goa Cabs';
import BestMumbaiToGoaCabService from './pages/Best Mumbai to Goa Cab Service';
import MumbaiToGoaCabBooking from './pages/Mumbai to Goa Cab Booking';
import Kharghartaxiservice from './pages/Kharghar Taxi Services';
import Mumbaiairportcabs from './pages/Mumbai Airport Cabs';
import Career from './pages/Career';
import Network from './pages/Network';
import Services from './pages/Services';
import Packages from './pages/Packages';
import Ourfleets from './pages/Ourfleets';
import Booking from './pages/Booking';
import ContactButtons from './components/ContactButtons';

function App() {
  return (
    <Router>
      <ContactButtons />
      <ScrollToTop />
<Header />
      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact-us" element={<ContactInfo />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/career" element={<Career />} />
        <Route path="/our-network" element={<Network />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/our-fleet" element={<Ourfleets />} />
        <Route path="/Mumbai-Outstation-Cabs" element={<Mumbaioutstationcabs />} />

<Route path="/Mumbai-to-Mahabaleshwar-Cab" element={<MumbaiToMahabaleshwarCab />} />
<Route path="/Mumbai-to-Goa-Cabs" element={<Mumbaitogoacabs />} />
<Route path="/Mumbai-to-Shirdi-Cab" element={<Mumbaitoshirdicaab />} />
<Route path="/Mumbai-to-Nashik-Cab" element={<Mumbaitonashikcab />} />
<Route path="/Mumbai-to-Kolhapur-Cab" element={<Mumbaitokolhapurcab />} />
<Route path="/Mumbai-to-Pune-Cab" element={<Mumbaitopunecab />} />
<Route path="/Mumbai-to-Aurangabad-Cab" element={<Mumbaitoaurangabadcab />} />
<Route path="/Mumbai-to-Bhimashankar-Cab" element={<Mumbaitobhimashankarcab />} />
<Route path="/Mumbai-to-Ashtavinayak-Cab-Service" element={<Mumbaitoashtavinayakcabservice />} />
<Route path="/Mumbai-to-5-Jyotirlinga-Cab" element={<Mumbaitofivejyotilingacab />} />
<Route path="/Mumbai-to-Lonavala-Cab" element={<Mumbaitolonavalacab />} />
<Route path="/Mumbai-to-Konkan-Darshan-Cab-Booking" element={<Mumbaitokonkandarshancabbooking />} />
<Route path="/Mumbai-to-Alibaug-Cab" element={<Mumbaitoalibaugcabs />} />
<Route path="/Mumbai-to-Ahmednagar-Cab" element={<Mumbaitoahmednagarcab />} />
<Route path="/Mumbai-to-Matheran-Cab" element={<Mumbaitomatherancab />} />
<Route path="/Mumbai-to-Jalgaon-Cab-Booking-Dhule" element={<Mumbaitojalgaoncabbookingdhule />} />
<Route path="/Mumbai-to-Lavasa-Cab" element={<Mumbaitolavasacab />} />
<Route path="/Mumbai-to-Panchgani-Cab" element={<Mumbaitopachmanicab />} />
<Route path="/Mumbai-to-Khandala-Taxi-Fare" element={<Mumbaitokhandalataxifare />} />
<Route path="/Mumbai-to-Surat-Cab" element={<Mumbaitosuratcab />} />
<Route path="/Mumbai-to-Ahmedabad-Cab" element={<MumbaitoahmedabadCab />} />
<Route path="/Mumbai-to-Narmada-Parikrama-Cab-Booking" element={<Mumbaitonarmadaparikramacabbooking />} />
<Route path="/Mumbai-to-Baroda-Cabs" element={<Mumbaitobarodacabs />} />
<Route path="/Mumbai-to-Daman-Taxi" element={<Mumbaitodamantaxi />} />
<Route path="/Mumbai-to-Vapi-Cab" element={<Mumbaitovapicabs />} />
<Route path="/Mumbai-to-Bangalore-Cab" element={<Mumbaitobangorecab />} />
<Route path="/Mumbai-to-Indore-Cab" element={<Mumbaitoindorecab />} />
<Route path="/Mumbai-to-Jaipur-Taxi" element={<Mumbaitojaipurtaxi />} />
<Route path="/Mumbai-Airport-to-Pune-Cabs" element={<Mumbaiairporttopunecabs />} />
<Route path="/Mumbai-to-Imagica-Cab" element={<Mumbaitoimagicacab />} />
<Route path="/Cab-Service-in-Mumbai" element={<Cabserviceinmumbai />} />
<Route path="/Best-Taxi-Service-in-Mumbai" element={<BestTaxiServiceInMumbai />} />
<Route path="/Online-Taxi-Booking-Mumbai" element={<Onlinetaxibookingmumbai />} />
<Route path="/Mumbai-Darshan-Cabs" element={<Mumbaidarshancabs />} />
<Route path="/Wedding-Car-Rental-Mumbai" element={<Weddingcaerentalmumbai />} />
<Route path="/One-Way-Cab-Service" element={<Onewaycabservice />} />
<Route path="/Corporate-Cab-Services-in-Mumbai" element={<Corporatecabserviceinmumbai />} />
<Route path="/Cab-Companies-in-Mumbai" element={<Cabcompaniesinmumbai />} />
<Route path="/Mumbai-Car-Rental-Service" element={<Mumbaicarrenatlservice />} />

<Route path="/Round-Trip-Cab-Booking-Mumbai" element={<Roundtripbookingmumbai />} />
<Route path="/Cab-Service-in-Thane" element={<Cabserviceinthane />} />
<Route path="/Cab-Service-Near-Me-Mumbai" element={<Cabservicenearmemumbai />} />
<Route path="/Swift-Dzire-on-Rent-in-Mumbai" element={<Swiftdzireonrentinmumbai />} />
<Route path="/Cab-Service-in-Navi-Mumbai" element={<Cabserviceinnavimumbai />} />
<Route path="/Taxi-Service-at-Mumbai-International-Airport" element={<Taxiserviceatmumbaiinternationalairport />} />
<Route path="/Cab-Service-in-Kalyan-Dombivali" element={<Cabserviceinkalyancabserviceindombivali />} />
<Route path="/Innova-Car-Rental-Mumbai" element={<Innovacarrentalmumbai />} />
<Route path="/Innova-Crysta-on-Rent-in-Mumbai" element={<InnovaCrystaOnRentInMumbai />} />
<Route path="/Ertiga-On-Rent-in-Mumbai" element={<ErtigaOnRentInMumbai   />} />
<Route path="/Sedan-Cab-Service-Mumbai" element={<SedanCabServiceMumbai />} />
<Route path="/Tempo-Traveller-On-Rent-Mumbai" element={<TempoTravellerOnRentMumbai />} />
<Route path="/Mini-Bus-on-Rent-in-Mumbai" element={<Minibusonretinmumbai />} />
<Route path="/Kia-Carens-Cab-Service-in-Mumbai" element={<Kiacarencecabserviceinmumbai />} />
<Route path="/Toyota-Etios-on-Rent-in-Mumbai" element={<Toyotaetiononrentinmumbai />} />
<Route path="/Car-Rental-Mumbai" element={<Carrentalmumbai />} />
<Route path="/Explore-India-Pan-India-Cab-Booking-Services" element={<Exploreindiapanindiacab />} />
<Route path="/Mumbai-to-Pandharpur-Akkalkot-Tuljapur-Cab-Booking" element={<MumbaitopandharpurAkkalkotTuljapurCabBooking />} />
<Route path="/Outstation-Taxi-Service-in-Mumbai" element={<Outstationtaxiserviceinmumbai />} />
<Route path="/Car-Hire-for-Outstation-in-Mumbai" element={<Carhireforoutstationinmumbai />} />
<Route path="/Mumbai-to-Hyderabad-Cabs" element={<Mumbaitohyderabadcabs />} />
<Route path="/Mumbai-Cab-Service" element={<Mumbaicabservice />} />
<Route path="/Best-Cab-Service-in-Mumbai" element={<Bestcabserviceinmumbai />} />
<Route path="/Mumbai-to-Ayodhya-Cab" element={<Mumbaitoayodhyacab />} />
<Route path="/Mumbai-to-Saputara-Cabs" element={<Mumbaitosaputaracabs />} />
<Route path="/Mumbai-to-Bhopal-Cab" element={<Mumbaitobhopalcab />} />
<Route path="/Mumbai-to-Telangana-Cab-Service" element={<Mumbaitotelanganacabservice />} />
<Route path="/Mumbai-to-Shani-Shingnapur-Cab" element={<Mumbaitoshanishiignapurcab />} />
<Route path="/Mumbai-to-Trimbakeshwar-Cab" element={<Mumbaitotrimbkeshwarcab />} />
<Route path="/Mumbai-Airport-to-Vadodara-Cab" element={<Mumbaiairporttovadodaracab />} />
<Route path="/Mumbai-to-Solapur-Cab" element={<Mumbaitosolapurcab />} />
<Route path="/Mumbai-to-Ratnagiri-Cab" element={<Mumbaitoratnagirircab />} />
<Route path="/Mumbai-to-Grishneshwar-Cab" element={<Mumbaitogridhneshwarcab />} />
<Route path="/Mumbai-to-Palghar-Cab" element={<Mumbaitopalgharcab />} />
<Route path="/Mumbai-to-Ujjain-Cab" element={<Mumbaitoujjaincab />} />
<Route path="/Mumbai-to-Jaipur-Cab" element={<Mumbaitojaipurcab />} />
<Route path="/Mumbai-to-Gujarat-Cab" element={<Mumbaitogujratcab />} />
<Route path="/Innova-On-Rent-Mumbai" element={<Innovaonrentmumbai />} />

<Route path="/Kia-Carens-On-Rent-in-Mumbai" element={<Kiacarenceonrentinmumbai />} />
<Route path="/Navi-Mumbai-Airport-Cab" element={<NavimumbaiAirportCab />} />
<Route path="/Navi-Mumbai-Airport-Cab-Service" element={<NaviMumbaiAirportCabService />} />
<Route path="/Navi-Mumbai-Airport-to-Pune-Cab" element={<NavimummbaiAirportToPuneCab />} />
<Route path="/Navi-Mumbai-Airport-to-Nashik-Cab" element={<NaviMumbaiAirportToNashikCab />} />
<Route path="/Online-Cab-Booking-Navi-Mumbai-Airport" element={<Onlinecabbookingnavimumbaiairport />} />
<Route path="/Navi-Mumbai-Airport-to-Lonavala-Cabs" element={<NavimumbaiAirportToLonavalaCabs />} />
<Route path="/Mumbai-Airport-Cab-Service" element={<MumbaiAirportCabService />} />
<Route path="/Navi-Mumbai-to-Mahabaleshwar-Cab" element={<NavimumbaiToMahabaleshwarCab />} />
<Route path="/Navi-Mumbai-to-Shirdi-Taxi-Fare" element={<NavimumbaitoshirdiTaxiFare />} />
<Route path="/Navi-Mumbai-Taxi-Service" element={<Navimumbaitaxiservice />} />
<Route path="/Cheapest-Cab-Service-in-Mumbai" element={<Cheapestcabserviceinmumbai />} />
<Route path="/Navi-Mumbai-to-Kolhapur-Cab" element={<NavimumbaiToKolhapurCab />} />
<Route path="/Innova-Crysta-On-Rent-in-Navi-Mumbai" element={<InnovacrystaOnRentNaviMumbai />} />
<Route path="/Ertiga-On-Rent-in-Navi-Mumbai" element={<Ertigaonrentinnavimumbai />} />
<Route path="/Swift-Dzire-On-Rent-in-Navi-Mumbai" element={<SwiftDzireOnRentInNaviMumbai />} />
<Route path="/Navi-Mumbai-Airport-to-Goa-Cabs" element={<NaviMumbaiAirportToGoaCabs />} />
<Route path="/Navi-Mumbai-International-Airport-Cab" element={<Navimumbaiinternatinalairportcab />} />
<Route path="/Navi-Mumbai-to-Ashtavinayak-Cab-Service" element={<NavimumbaiToAshtavinayakCabService />} />
<Route path="/Navi-Mumbai-to-5-Jyotirlinga-Darshan-Cab" element={<Navimumbaitofivejyotilingadarshan />} />
<Route path="/Round-Trip-Cab-Navi-Mumbai" element={<Roundtripcabnavimumbai />} />
<Route path="/Outstation-Cab-Service-Navi-Mumbai" element={<OutstationCabServiceNaviMumbai />} />
<Route path="/Navi-Mumbai-to-Pune-Daily-Cab-Service" element={<NavimumbaitopuneDailyCabService />} />
<Route path="/Navi-Mumbai-Corporate-Cab-Service" element={<NaviMumbaiCorporateCabService />} />
<Route path="/Navi-Mumbai-International-Airport-NMIA-Cabs" element={<NavimumbaiinternationalAirportCabs />} />
<Route path="/Mumbai-to-Khatu-Shyam-Cab" element={<MumbaiToKhatuShyamCab />} />
<Route path="/Mumbai-to-Nagpur-Cab" element={<Mumbaitonagpurcab />} />
<Route path="/Mumbai-to-Pimpri-Chinchwad-Cabs" element={<Mumbaitopimprichichwadcabs />} />
<Route path="/Navi-Mumbai-to-Goa-Cab-Service" element={<NaviMumbaiToGoaCabService />} />
<Route path="/Mumbai-Airport-to-Goa-Cab" element={<Mumbaiairporttogoacab />} />
<Route path="/Mumbai-to-Goa-One-Way-Cab" element={<MumbaiToGoaOneWayCab />} />
<Route path="/Thane-to-Goa-Cabs" element={<ThaneToGoaCabs />} />
<Route path="/Best-Mumbai-to-Goa-Cab-Service" element={<BestMumbaiToGoaCabService />} />
<Route path="/Mumbai-to-Goa-Cab-Booking" element={<MumbaiToGoaCabBooking />} />
<Route path="/Kharghar-Taxi-Services" element={<Kharghartaxiservice />} />
<Route path="/Mumbai-Airport-Cabs" element={<Mumbaiairportcabs />} />

      </Routes>



      <Footer />
    </Router>
  );
}

export default App;
